import React from "react";
import {
  GridColumnMenu,
  GridColumnMenuItemProps,
  GridColumnMenuProps,
  useGridApiContext,
  useGridRootProps,
} from "@mui/x-data-grid-pro";

/**
 * Custom filter menu item that stores the target column field on apiRef
 * before opening the filter panel, so FilterBuilderFilterPanel can
 * pre-select the attribute.
 */
const CustomColumnMenuFilterItem = (props: GridColumnMenuItemProps) => {
  const { colDef, onClick } = props;
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      onClick(event);

      // Store the target field on the apiRef so FilterBuilderFilterPanel can read it
      (apiRef.current as any).__columnFilterField = colDef.field;

      apiRef.current.showFilterPanel();
    },
    [apiRef, colDef.field, onClick]
  );

  if (rootProps.disableColumnFilter || !colDef.filterable) {
    return null;
  }

  return (
    <rootProps.slots.baseMenuItem
      onClick={handleClick}
      iconStart={<rootProps.slots.columnMenuFilterIcon fontSize="small" />}
    >
      {apiRef.current.getLocaleText("columnMenuFilter")}
    </rootProps.slots.baseMenuItem>
  );
};

const CustomColumnMenu = (props: GridColumnMenuProps) => (
  <GridColumnMenu
    {...props}
    slots={{
      columnMenuColumnsItem: null,
      columnMenuFilterItem: CustomColumnMenuFilterItem,
    }}
  />
);

export default CustomColumnMenu;
